import { useMutation, useQueryClient } from "react-query";
import { axiosInstance } from "../../config/axios";
import { QueryKeys } from "../queryKeys";

export interface IMoveToResponseCodeRequest {
  id: number;
  internalErrorCode: string;
}

async function moveToResponseCode(
  params: IMoveToResponseCodeRequest
): Promise<any> {
  const { data } = await axiosInstance.post("/ResponseCode/MoveToResponseCode", params);
  return data;
}

export function useMoveToResponseCode() {
  const queryClient = useQueryClient();
  return useMutation((params: IMoveToResponseCodeRequest) => moveToResponseCode(params), {
    onSuccess: () => {
      queryClient.invalidateQueries(QueryKeys.responseCodes);
      queryClient.invalidateQueries(QueryKeys.newResponseCodes);
    },
  });
}
